import React, { useState } from "react";

import styled from "@emotion/styled";
import {
  Checkbox,
  FormControlLabel,
  Paper,
  Switch,
  Typography,
  Button,
  Box,
} from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Avatar from "@mui/material/Avatar";
import ExpandCircleDownOutlinedIcon from "@mui/icons-material/ExpandCircleDownOutlined";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import { useTheme } from "@mui/material/styles";

import { useNavigate, Link } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";

import BackButton from "../../../components/BackButton";

// import {
//   updateNotificationPrefrence,
//   updateRegistrationDetail,
// } from "../slice";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";

// import { EntityType, RegistrationStatus, UserType } from "../../../common/enum";
import { getProductList } from "../../DonationView/slice";
import { PRODUCT_ICON } from "../../../common/enum/productIcon";
import DistanceFilter from "../../DashBoardView/CollectorDonationView/DistanceFilter";
import { platformOptions } from "../../../data";
import { useSnackbar } from "notistack";
import { getUserEntity } from "../../../redux/features/authSlice";
import { AddressData } from "../../../common/enum/addressData";
import BlacklistEntity from "../../BlacklistEntity";
import Drawer from "@mui/material/Drawer";
import EntidadeBeneficiaria from "../../EntidadeBeneficiaria/EntidadeBeneficiaria";
import { useData } from '../DataContext';
import {
  ComponentType,
  UserType,
  RegistrationStatus,
  DocumentStatus,
  FileType,
  EntityType,
  isCAActive
} from "../../../common/enum";
import {
  updateNotificationPrefrence,
  setCurrentTab,
  addUserAddress,
  addUserContact,
  addUserDetail,
  setDisableFrom,
  updateRegistrationDetail,
  documentFileUpload,
  setBannerUri,
  setProfileUri,
  addEntityDocuments,
} from "../../OnBoarding/slice";
import { GetEntityPreferenceEmail } from "../../CreateCollection/slice";
const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 52,
  height: 26,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(26px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: theme.palette.mode === "dark" ? "#2ECA45" : "#65C466",
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color:
        theme.palette.mode === "light"
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 22,
    height: 22,
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));

const StyledSwitch = styled(Switch)(({ theme }) => ({
  width: 70,
  height: 30,
  padding: 12,
  "& .MuiSwitch-switchBase": {
    margin: 2,
    padding: 0,
    transform: "translateX(6px)",
    "&.Mui-checked": {
      color: "#fff",
      transform: "translateX(38px)",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: "#37B34A",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    backgroundColor: "#fff",
    width: 24,
    height: 24,
    border: "2px solid #37B34A",
    borderRaidus: "50%",
    "&:before": {
      content: "''",
      position: "absolute",
      width: "100%",
      height: "100%",
      left: 0,
      top: 0,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
    },
  },
  "& .MuiSwitch-track": {
    opacity: 1,
    backgroundColor: theme.palette.mode === "dark" ? "#8796A5" : "#aab4be",
    borderRadius: 20 / 2,
  },
}));

const RegisterNotificationData = ({ currentQuestion, t, inDashboard = false }) => {
  const { sharedData } = useData();
 
  // Extract individual pieces of data
  const {  data, identificationType,RegistrationStatus,businessRegistrationUri,select1,select2,select3,position,profileUri,bannerUri, entityTypeOptionsValue,activityOptionsValue,mandatedStatementUri} = sharedData;
  //console.log(data , "guardou")
  const theme = useTheme();
  const [drawerState, setDrawerState] = React.useState(false);
  const [drawerState2, setDrawerState2] = React.useState(false);
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [NotEmail, setNotEmail] = useState([]);
  const IsHibrid = {isArtigosFavoritos : false , isDoacaoCancelada: false , isProximo: false , isNovaMensagem: false , isReservaCancelada: false, isFimDoacao: false , isNovaReserva: false , IsEntidadeBeneficiaria:false};
  const IsNotDonorNotificacaoes = {isArtigosFavoritos : false , isDoacaoCancelada: false , isProximo: false , isNovaMensagem: false , IsEntidadeBeneficiaria:false};
  const IsDonorNotificacoes = {isFimDoacao: false , isNovaMensagem: false , isNovaReserva: false , isReservaCancelada: false};
  const IsAlternativeNotificacoes = {isArtigosFavoritos : false , isDoacaoCancelada: false , isProximo: false , isNovaMensagem: false, isNewAlternativeDonation:false, IsEntidadeBeneficiaria:false};
  const [showError, setShowError] = useState(null);
  const [businessRegError, setBusinessRegError] = useState(false);
	const [positionError, setPositionError] = useState(false);

  // reducx selector
  const {
    auth: {
      user: { userId },
      profile,
    },
    donationCart: { productList },
    onBoarding: { profileOptionsValue },
    dashboardInfo: { entityProfileSelect },
  } = useSelector((state) => state);
  const { favoriteProducts, entityPreference } = profile;
  const [checked, setChecked] = React.useState(false);
  const distanceFilterObj = {
    offerDistance:
      inDashboard && profile?.entityPreference !== null
        ? profile?.entityPreference?.isDistanceOffer
        : true,
    location:
      inDashboard && profile?.entityPreference !== null
        ? !profile?.entityPreference.isDistanceOffer
        : false,
  };

  const [distanceFilterCheck, setDistnaceFilterCheck] =
    React.useState(distanceFilterObj);
  const [selectDistrict, setSelectDistrict] = React.useState(
    (inDashboard && profile?.entityPreference !== null)
      ? profile?.entityPreference?.district
      : sharedData.select1 ? sharedData.select1 : null
  );
  const [selectCounty, setSelectCounty] = React.useState(() => {
    if (
      inDashboard &&
      profile?.entityPreference !== null &&
      profile?.entityPreference?.county !== null
    ) {
      const data = profile?.entityPreference?.county.split(",");
      if (
        AddressData.find(
          (d) => d.district === profile?.entityPreference?.district
        )?.county.length === data.length
      ) {
        data.unshift("Todos");
        return data;
      } else {
        return data;
      }
    } else if (sharedData.select2) {
      var rr = [];
      rr.push (sharedData.select2)
      return rr;
    }else {
      return [];
    }
  });

  const [distance, setDistance] = React.useState(
    inDashboard && profile?.entityPreference !== null && profile?.entityPreference?.distance != 0
      ? profile?.entityPreference?.distance
      : 1
  );
  const [notificationPlatform, setNotificationPlatform] = React.useState(
    inDashboard
      ? profile?.entityPreference !== null &&
          profile?.entityPreference?.isNotificationPlatform
      : true
  );
  const [messagePrefrence, setMessagePrefrence] = React.useState(
    inDashboard
      ? profile?.entityPreference !== null &&
          profile?.entityPreference?.isMessages
      : false
  );
  const [productGroup, setProductGroup] = React.useState({});

  const dispatch = useDispatch();

  const handleNotificationChange = React.useCallback(
    (e) => {
      if (e.target.name === "message") {
        setMessagePrefrence(!messagePrefrence);

        Object.entries(NotEmail).map(([campo, valor], index) => (
          NotEmail[campo] = e.target.checked
        ))
          setNotEmail(NotEmail);

      } else {
        setNotificationPlatform(!notificationPlatform);
      }
    },
    [messagePrefrence, notificationPlatform, NotEmail]
  );

  const favProduct = React.useMemo(() => {
    let products = [];
    if (Object.keys(productGroup).length > 0) {
      for (let item in productGroup) {
        for (let itemType in productGroup[item]) {
          if (itemType !== "isFavoriteGroup") {
            for (let pro of productGroup[item][itemType].product) {
              if (pro.isFavorite === true) {
                products.push(pro);
              }
            }
          }
        }
      }
    }
    return products;
  }, [productGroup]);

  const addNotificationPrefernce = React.useCallback(async () => {
    const payload = {
      entityId: userId,
      isNotificationPlatform: notificationPlatform,
      isMessages: messagePrefrence,
      favoriteProductList: favProduct,
      isDistanceOffer: distanceFilterCheck.offerDistance ? true : false,
      distance: distanceFilterCheck.offerDistance ? distance : 0,
      district: selectDistrict,
      county: `${selectCounty.filter((v) => v !== "Todos")}`,
      isDonor : !isNotDonor,
      isProximo: NotEmail.isProximo == undefined ? null :  NotEmail.isProximo,
      isNovaMensagem: NotEmail.isNovaMensagem == undefined ? null : NotEmail.isNovaMensagem,
      isNovaReserva: NotEmail.isNovaReserva == undefined ? null : NotEmail.isNovaReserva,
      isDoacaoCancelada: NotEmail.isDoacaoCancelada == undefined ? null : NotEmail.isDoacaoCancelada,
      isArtigosFavoritos: NotEmail.isArtigosFavoritos == undefined ? null : NotEmail.isArtigosFavoritos,
      isReservaCancelada: NotEmail.isReservaCancelada == undefined? null : NotEmail.isReservaCancelada,
      isFimDoacao: NotEmail.isFimDoacao == undefined ? null : NotEmail.isFimDoacao,
      isNewAlternativeDonation: isCAActive == true ? NotEmail.isNewAlternativeDonation == undefined ? null : NotEmail.isNewAlternativeDonation : null
    };
    dispatch(updateNotificationPrefrence(payload))
      .unwrap()
      .then((res) => {
        if (inDashboard) {
          enqueueSnackbar({
            message: t("settingUpdatedSuccessfully"),
            variant: "success",
            autoHideDuration: 3000,
          });
          dispatch(getUserEntity(userId));
        }
      })
      .catch((error) => {
        enqueueSnackbar({
          message: t("incapaz de guardar a preferência de notificação"),
          variant: "error",
        });
      });
  }, [
    notificationPlatform,
    messagePrefrence,
    distance,
    distanceFilterCheck,
    favProduct,
    selectCounty,
    selectDistrict,
    NotEmail
  ]);

  
  const uploadDocumnetDetails = async (filetype, fileName) => {
    const documnetDetails = {
      loggedInUserId: userId,
      entityId: userId,
      updatedBy: userId,
      status: DocumentStatus.waitingForValidation,
      fileType: filetype,
      fileName: fileName,
    };
    dispatch(addEntityDocuments(documnetDetails));
  };

  const handleSubmit = React.useCallback(async () => {
    const dataSubmition = sharedData.data;
    const {
      name,
      NIF_NIPC,
      mobile,
      companyName,
      email,
      locality,
      address,
      postalCode1,
      postalCode2,
      designation,
      addressTitle,
      emailForAddress,
      phone,
      houseHold,
      contactName,
      ...addressData
    } = sharedData.data;
    ///// add contacts/adress/info user
    if (sharedData.identificationType === ComponentType.IDENTIFICATION_TYPE) {
        const data = {
          email: dataSubmition.emailForAddress.toLowerCase(),
          password: "Test123",
          userType: dataSubmition.UserType.entity,
          status: dataSubmition.RegistrationStatus.registering,
          createdBy: userId,
        };

        dispatch(setIdentitifcationType(identificationType));
        await dispatch(register({ data }))
          .unwrap()
          .then((res) => {
            //console.log("res", res);
            const addressPayload = {
              entityId: res.userId,
              id: 0,
              addressTitle,
              addressLine: houseHold,
              district: select1,
              county: select2,
              subDivision: select3,
              postalCode: `${postalCode1}-${postalCode2}`,
              locality,
              latitude: position.lat,
              longitude: position.lng,
              phone,
              email: emailForAddress,
              isHeadquarter: false,
              isExternal: false,
              updatedBy: entity.entityId,
            };
            if (res.userId !== undefined) {
              
              dispatch(addUserAddress(addressPayload))
                .unwrap()
                .then((resAddress) => {
                  const contactPayload = {
                    entityId: res.userId,
                    name: contactName,
                    mobile,
                    email,
                    designation,
                    telephone: "",
                    isOfficialRepresentative: true,
                    isPrimaryContact: true,
                    updatedBy: entity.entityId,
                  };
                  dispatch(addUserContact(contactPayload))
                    .unwrap()
                    .then((responseContact) => {
                      const userDetails = {
                        entityName: companyName,
                        userTypeId: 0,
                        entityId: res.userId,
                        entityType: entity.entityType, //entityType //profileOption
                        nic: entity.nic,
                        websiteUrl: "string",
                        profilePicture: "string",
                        tin: "string",
                        occupation: "string",
                        isGroupEntity: entity.isGroupEntity, // entityTypeOption
                        areaOfActivity: entity.areaOfActivity, // activityOption
                        isParentEntity: entityTypeOptionsValue,
                        contactId: responseContact.contactDetails.contactId,
                        entityAddressId: resAddress.addressDetails.addressId,
                        cae: "string",
                        parentEntityId: entity.entityId,
                      };
                      dispatch(addUserDetail(userDetails))
                        .unwrap()
                        .then(() => {
                          const payload = {
                            userId: res.userId,
                            status: RegistrationStatus.invited,
                          };
                          dispatch(updateRegistrationDetail(payload))
                            .unwrap()
                            .then(() => {
                              navigate("/dashboard", { replace: true });
                              dispatch(setDashboardTab("manageBranches"));
                              dispatch(setIdentitifcationType(""));
                            });
                          enqueueSnackbar({
                            message: t("branchAddedSuccessfulMessage"),
                            variant: "success",
                          });
                        });
                    });
                });
            } else {
              enqueueSnackbar({
                message: t("emailAlreadyExist"),
                variant: "error",
              });
            }
          })
          .catch((error) => {
            //console.log(error);
            enqueueSnackbar({
              message: t("emailAlreadyExist"),
              variant: "error",
            });
          });
      
    } else {
      if (
        businessRegistrationUri === null ||
        select1 === null ||
        select2 === null ||
        select3 === null ||
        position === null
      ) {
        if (select1 === null || select2 === null || select3 === null) {
          setShowError(true);
        }
        if (businessRegistrationUri === null) {
          setBusinessRegError(true);
        }
        if (position === null) {
          setPositionError(true);
        }
      } else {
        const payload = {
          entityId: userId,
          id: 0,
          addressTitle,
          addressLine: houseHold,
          district: select1,
          county: select2,
          subDivision: select3,
          postalCode: `${postalCode1}-${postalCode2}`,
          locality,
          latitude: position.lat,
          longitude: position.lng,
          phone,
          email: emailForAddress,
          isHeadquarter: true,
          isExternal: false,
        };

        const contactPayload = {
          entityId: userId,
          name: contactName,
          mobile,
          email,
          designation,
          telephone: "",
          isOfficialRepresentative: true,
          isPrimaryContact: true,
        };

        await dispatch(addUserAddress(payload))
          .unwrap()
          .then((successResult) => {
            dispatch(addUserContact(contactPayload))
              .unwrap()
              .then((contactResponse) => {
                const userDetails = {
                  entityName: companyName,
                  userTypeId: 0,
                  entityId: userId,
                  entityType: profileOptionsValue, //entityType //profileOption
                  nic: NIF_NIPC,
                  websiteUrl: "string",
                  profilePicture: profileUri.length > 0 ? profileUri : "string",
                  bannerImage: bannerUri.length > 0 ? bannerUri : "string",
                  tin: "string",
                  occupation: "string",
                  isGroupEntity: entityTypeOptionsValue, // entityTypeOption
                  areaOfActivity: activityOptionsValue, // activityOption
                  isParentEntity: entityTypeOptionsValue,
                  contactId: contactResponse.contactDetails.contactId,
                  entityAddressId: successResult.addressDetails.addressId,
                  cae: "string",
                  parentId: null,
                  businessRegistrationUri: businessRegistrationUri,
                  mandatedStatementUri: mandatedStatementUri,
                };
                dispatch(addUserDetail(userDetails));
                dispatch(getProductList());
                dispatch(setBannerUri(""));
                dispatch(setProfileUri(""));
                // dispatch(setDisableFrom(5));
                // dispatch(setCurrentTab(4));
              });
          })
          .catch((error) => {
            //console.log(error);
            alert("Address or Contact details are not added");
          });
        await uploadDocumnetDetails(
          FileType.businessRegistration,
          businessRegistrationUri
        );
        if (mandatedStatementUri?.length > 0) {
          await uploadDocumnetDetails(
            FileType.mandatedStatement,
            mandatedStatementUri
          );
        }
      }
    }

    ////// add Notification
    const payload = {
      userId: userId,
      status: RegistrationStatus.pendingEmailVerification,
    };
    await addNotificationPrefernce();
    if (!inDashboard) {
      dispatch(updateRegistrationDetail(payload))
        .unwrap()
        .then((response) => {
          navigate("/registration-success", {
            state: { email: response.result.email },
          });
        })
        .catch((error) => {
          enqueueSnackbar({
            message: t("somethingWentWrong"),
            variant: "error",
          });
        });
    }
  }, [dispatch, navigate, addNotificationPrefernce]);

  

  const loadProduct = async () => {
    dispatch(getProductList());
  };

  React.useEffect(() => {
    loadProduct();
    const data = {
      entityId: userId,
    };
    dispatch(GetEntityPreferenceEmail(data))
    .unwrap()
    .then((res) => {
      const { entityId, idPreference, isDonor, ...filteredNotEmail } = res;

      // Filtrar propriedades nulas
      const finalNotEmail = Object.fromEntries(
        Object.entries(filteredNotEmail).filter(([key, value]) => value !== null)
      );
  
      // Definir o estado apenas com as propriedades não nulas
      setNotEmail(finalNotEmail);
      
    })
    .catch((error) => {
      profileOptionsValue === EntityType.donor ||
      profile?.entity?.entityType === EntityType.donor?
      setNotEmail(IsDonorNotificacoes)
      : profile?.entity?.entityType === "SPECIAL_DISTRIBUTOR" || profileOptionsValue === "SPECIAL_DISTRIBUTOR"  ? 
      setNotEmail(IsAlternativeNotificacoes)
      : profile?.entity?.entityType === "DONOR_DISTRIBUTOR" || profileOptionsValue === "DONOR_DISTRIBUTOR" ? 
      setNotEmail(IsHibrid)
      :
      setNotEmail(IsNotDonorNotificacaoes)
    });
  }, []);

  const groupDonationProduct = React.useMemo(() => {
    const accProducts= productList?.reduce((acc, pro) => {
      if (!acc[pro.productGroup]) {
        acc[pro.productGroup] = {};
      }
      let isProductGroupExists = false;
      let isProductTypeExists = false;
      if (inDashboard && favoriteProducts.length > 0) {
        const favProductArray = productList.filter((item) =>
          favoriteProducts.find((f) => f.productId == item.productId)
        );
        const favPGroup = favProductArray.find(
          (f) =>
            f.productGroup === pro.productGroup && f.productId === pro.productId
        );
        const favPType = favProductArray.find(
          (p) =>
            p.productType === pro.productType && p.productId === pro.productId
        );
        isProductGroupExists = favPGroup ? true : false;
        isProductTypeExists = favPType ? true : false;
      }
      acc[pro.productGroup]["isFavoriteGroup"] = isProductGroupExists;
      if (!acc[pro.productGroup][pro.productType]) {
        acc[pro.productGroup][pro.productType] = {};
      }
      acc[pro.productGroup][pro.productType]["isFavoriteType"] =
        isProductTypeExists;
      if (!acc[pro.productGroup][pro.productType]["product"]) {
        acc[pro.productGroup][pro.productType]["product"] = [];
      }
      const isDashboardValue = profile?.favoriteProducts?.find(
        (item) => Number(item.productId) === pro.productId
      )?.isFavorite === undefined ? false : true

      const newPro = Object.assign(
        {},
        {
          isFavorite: inDashboard
            ? isDashboardValue : false,
          productId: pro.productId,
          productGroup: pro.productGroup,
        }
      );
      acc[pro.productGroup][pro.productType]["product"].push(newPro);
      return acc;
    }, {});
    setProductGroup(accProducts);
    return accProducts
  }, [productList, inDashboard]);

  const handleNotificationMessageChange = React.useCallback(
    (e, campo) => {
      const newNotEmail = { ...NotEmail };
    
    // Faça as modificações na cópia
    newNotEmail[campo] = e.target.checked;

    // Atualize o estado usando a função setNotEmail
    setNotEmail(newNotEmail);
  },
  [NotEmail, setNotEmail]
  );

  const handleProductGroup = React.useCallback(
    (e) => {
      productGroup[e.target.name].isFavoriteGroup = e.target.checked;
      for (let pro in productGroup[e.target.name]) {
        if (pro !== "isFavoriteGroup") {
          productGroup[e.target.name][pro].isFavoriteType = e.target.checked;
          // pro.isFavoriteType = e.target.checked;
          productGroup[e.target.name][pro].product.map(
            (item) => (item.isFavorite = e.target.checked)
          );
        }
      }
      setProductGroup({ ...productGroup });
    },
    [productGroup]
  );

  const handleProductTypeChange = React.useCallback(
    (e, proGroup) => {
      productGroup[proGroup][e.target.name].isFavoriteType = e.target.checked;
      productGroup[proGroup][e.target.name].product.map(
        (item) => (item.isFavorite = e.target.checked)
      );
      let trueCount = 0;
      for (let p in productGroup[proGroup]) {
        if (productGroup[proGroup][p].isFavoriteType === true) {
          trueCount++;
        }
      }
      // productGroup[proGroup].isFavoriteGroup =
      //   Object.keys(productGroup[proGroup]).length - 1 === trueCount;
      productGroup[proGroup].isFavoriteGroup = trueCount > 0
      setProductGroup({ ...productGroup });
    },
    [productGroup]
  );

  const isNotDonor = React.useMemo(() => {
    return !(
      profileOptionsValue === EntityType.donor ||
      profile?.entity?.entityType === EntityType.donor
    );
  }, [profileOptionsValue, profile]);
 const handleSwitchClick = (e) => {
    // Prevent the click event from propagating to the AccordionSummary
    e.stopPropagation();
  };
  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          p: 1,
          [theme.breakpoints.up("md")]: {
            ml: inDashboard === true ? 0 : 12,
          },
          mx: 1,
        }}
      >
        {currentQuestion?.options?.map((item, index) => (
    <Paper
      sx={{
        width: "100%",
        [theme.breakpoints.up("md")]: {
          width: inDashboard === true ? "100%" : "50%",
        },
        marginTop: "2%",
        display: "flex",
        flexDirection: "column", // Empilhar verticalmente
        padding: "10px",
        justifyContent: "space-between",
      }}
      key={index}
    >
      <Box
        sx={{display: "flex",
          flexDirection: "row",
          flexWrap: "nowrap",
          justifyContent: "space-between"
        }}
      >
        <Box>
        <Typography variant="h2" style={{ fontSize: "1rem" }}>
          {t(item.title)}
        </Typography>
        <Typography fontSize={12} color={"text.secondary"}>
          {t(item.sub)}
        </Typography>
        </Box>
        
 
        <FormControlLabel
          control={
            <IOSSwitch
              sx={{ m: 1 }}
              checked={
                item.title === platformOptions.options[0].title
                  ? notificationPlatform
                  : messagePrefrence
              }
              onChange={handleNotificationChange}
              name={
                item.title === platformOptions.options[0].title
                  ? "notificationPlatform"
                  : "message"
              }
            />
          }
          label={
            <Typography sx={{ display: "none" }}>{t(item.title)}</Typography>
          }
        />
      
      </Box>
      
      {item.title == "platformUserMessage" &&       
      (<Typography
      sx={{
        lineHeight: "1.5",
        fontFamily: "Poppins",
        fontSize: "1rem",
        fontWeight: "500",
        fontSize: "14px",
        color: "#637381",
        mt: 2,
        mb: 2
      }}
      >
        Se desativar as notificações por e-mail continuará a receber as necessárias para o bom funcionamento da plataforma
        </Typography>)}
      {/* Segunda sequência de Boxes */}
      {item.title === "platformUserMessage" && (
        
          Object.entries(NotEmail).map(([campo, valor], index) => (
            campo != 'entityId' && campo != 'isDonor' && campo != 'idPreference' && valor != null &&
            <Paper
            variant="outlined"
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              p: 1,
              my: 1,
            }}
            key={index}
        >
          <Typography variant="body1">{t(`${campo}`)}</Typography>{" "}
          <StyledSwitch
            checked={
              valor
            }
            onChange={(e) => handleNotificationMessageChange(e, campo)}
            //name={itemType}
          />
        </Paper>
          )) 
      )}
    </Paper>
  ))}
        {isNotDonor && (
          <Paper
            sx={{
              width: "100%",
              [theme.breakpoints.up("md")]: {
                width: inDashboard === true ? "100%" : "50%",
              },
              marginTop: "2%",
              display: "flex",
              padding: "10px",
              justifyContent: "space-between",
              flexDirection: "column",
            }}
          >
            <Box mb={1}>
              <Typography variant="subtitle1">
                {t("notificationFaviorateArtigoHeading")}
              </Typography>
              <Typography fontSize={12} color={"text.secondary"} gutterBottom>
                {t("notificationFaviorateArtigoSubHeading")}
              </Typography>
            </Box>
            {groupDonationProduct !== undefined &&
              Object.keys(groupDonationProduct)?.map((item, index) => (
                <Accordion key={index}>
                  <AccordionSummary
                    expandIcon={<ExpandCircleDownOutlinedIcon  sx={{
                      //pointerEvents: "auto",
                    }}/> }
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    sx={{
                     // pointerEvents: "none",
                      backgroundColor: "#e1efb0",
                      "& .MuiAccordionSummary-content": {
                        justifyContent: "space-between",
                        alignItems: "center",
                      },
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Avatar
                        alt={
                          PRODUCT_ICON.find(
                            (itemIcon) => itemIcon.productGroup === item
                          ).productGroup
                        }
                        src={
                          PRODUCT_ICON.find(
                            (itemIcon) => itemIcon.productGroup === item
                          ).url
                        }
                        sx={{
                          width: 24,
                          height: 24,
                          ml: 0.2,
                          mr: 1,
                        }}
                      />
                      <Typography variant="h6">{item}</Typography>
                    </Box>
                    <FormControlLabel
                      control={
                        <IOSSwitch
                          sx={{ m: 1 ,  }}
                          checked={
                            productGroup !== undefined
                              ? productGroup[item]?.isFavoriteGroup
                              : false
                          }
                          onClick={handleSwitchClick}
                          onChange={handleProductGroup}
                          name={item}
                        />
                      }
                    />
                  </AccordionSummary>
                  <AccordionDetails>
                    {Object.keys(groupDonationProduct[item]).map(
                      (itemType, index) =>
                        itemType !== "" &&
                        itemType !== "isFavoriteGroup" && (
                          <Paper
                            variant="outlined"
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              p: 1,
                              my: 1,
                            }}
                            key={index}
                          >
                            <Typography variant="body1">{itemType}</Typography>{" "}
                            <StyledSwitch
                              checked={
                                Object.keys(productGroup).length > 0
                                  ? productGroup[item][itemType]?.isFavoriteType
                                  : false
                              }
                              onChange={(e) => handleProductTypeChange(e, item)}
                              name={itemType}
                            />
                          </Paper>
                        )
                    )}
                  </AccordionDetails>
                </Accordion>
              ))}
          </Paper>
        )}
        {isNotDonor && (
          <Paper
            sx={{
              width: "100%",
              [theme.breakpoints.up("md")]: {
                width: inDashboard === true ? "100%" : "50%",
              },
              marginTop: "2%",
              display: "flex",
              padding: "10px",
              justifyContent: "space-between",
              flexDirection: "column",
            }}
          >
            <Box mb={1}>
              <Typography variant="subtitle1">
                {t("notificationFaviorateProximityHeading")}
              </Typography>
              <Typography fontSize={12} color={"text.secondary"} gutterBottom>
                {t("notificationFaviorateProximitySubHeading")}
              </Typography>
            </Box>
            <DistanceFilter
              distanceFilterObj={distanceFilterObj}
              distanceFilterCheck={distanceFilterCheck}
              setDistnaceFilterCheck={setDistnaceFilterCheck}
              selectDistrict={selectDistrict}
              setSelectDistrict={setSelectDistrict}
              selectCounty={selectCounty}
              setSelectCounty={setSelectCounty}
              distance={distance}
              setDistance={setDistance}
              settingComponent={true}
              t={t}
            />
          </Paper>
        )}
        {inDashboard &&
          (profile?.entity?.entityType === EntityType.donor ||
            (profile?.entity?.entityType === EntityType.donorDistributor &&
              entityProfileSelect === EntityType.donor)) && (
            <Paper
           
              sx={{
                width: "100%",
                [theme.breakpoints.up("md")]: {
                  width: "100%",
                },
                marginTop: "2%",
                display: "flex",
                padding: "10px",
                justifyContent: "space-between",
                flexDirection: "row",
              }}
            >
              <Box>
                <Typography variant="subtitle1">{'Entidades beneficiárias'}</Typography>
                <Typography fontSize={12} color={"text.secondary"}>
                  {'Doação apenas disponível para as entidades beneficiárias'}
                </Typography>
              </Box>
              <Button
                sx={{
                  fontWeight: 600,
                  textDecoration: "underline",
                  color: "#1c727e",
                  p: "0px !important",
                  "&:hover": {
                    backgroundColor: "transparent",
                    textDecoration: "underline",
                  },
                  borderRadius:"4px"
                }}
                onClick={() => setDrawerState2(true)}
              >
                {t("consult")}
              </Button>
            </Paper>
          )}
        {inDashboard &&
          (profile?.entity?.entityType === EntityType.donor ||
            (profile?.entity?.entityType === EntityType.donorDistributor &&
              entityProfileSelect === EntityType.donor)) && (
            <Paper
              sx={{
                width: "100%",
                paddingTop: "16px",
                [theme.breakpoints.up("md")]: {
                  width: "100%",
                },
                marginTop: "2%",
                display: "flex",
                padding: "10px",
                justifyContent: "space-between",
                flexDirection: "row",
              }}
            >
              <Box>
                <Typography variant="subtitle1">{t('excludedEntites')}</Typography>
                <Typography fontSize={12} color={"text.secondary"}>
                  {t('donationNotAviableForExcludedEntities')}
                </Typography>
              </Box>
              <Button
                sx={{
                  fontWeight: 600,
                  textDecoration: "underline",
                  color: "#1c727e",
                  p: "0px !important",
                  "&:hover": {
                    backgroundColor: "transparent",
                    textDecoration: "underline",
                  },
                  borderRadius:"4px"
                }}
                onClick={() => setDrawerState(true)}
              >
                {t("consult")}
              </Button>
            </Paper>
          )}
          
        {!inDashboard && (
          <>
            <Typography sx={{ marginTop: "2%" }}>
              {t(currentQuestion?.platformDescription)}
            </Typography>
            <span style={{ marginTop: "2%" }}>
              <Checkbox
                checked={checked}
                onChange={(event) => setChecked(event.target.checked)}
                color="success"
                size="medium"
                sx={{
                  "&.Mui-disabled": {
                    color: "#54D62C !important",
                  },
                }}
              />
              <Typography
                display={"inline"}
                variant="body2"
                sx={{ color: "text.secondary", mt: 3 }}
              >
                {t("platformConfirmation")}{" "}
                <Link underline="always" color="text.primary" target="_blank" to="https://tomaladaca.gov.pt/termos-e-condicoes-de-utilizacao/">
                  {t("termsAndConditions")}
                </Link>
              </Typography>
            </span>
          </>
        )}
        {profile?.userType !== UserType.entityManager && (
          <Box sx={{ marginTop: "2%" }}>
            {!inDashboard && (
              <BackButton
                style={{
                  mr: 2,
                }}
              />
            )}
            <Button
              size="large"
              variant="contained"
              onClick={handleSubmit}
              type="submit"
              disabled={inDashboard ? false : !checked}
              sx={{borderRadius:"4px"}}
              endIcon={<CheckCircleOutlineOutlinedIcon fontSize="16px" />}
            >
              {inDashboard ? t("toSave") : t("finalize")}
            </Button>
          </Box>
        )}
      </Box>
      <Drawer
        anchor={"right"}
        open={drawerState}
        PaperProps={{
          sx: { width: "50%" },
        }}
        onClose={() => {
          setDrawerState(false);
        }}
      >
        <Button
          sx={{
            position: "fixed",
            right: "51%",
            top: 10,
            zIndex: 1,
            minWidth: 0,
            borderRadius: "4px",
            padding: "4px",
            backgroundColor: "#ffc3c3",
            "&:hover": {
              backgroundColor: "#ffc3c3",
            },
          }}
          onClick={() => setDrawerState(false)}
        >
          <CloseOutlinedIcon color="error" />
        </Button>
        <BlacklistEntity  t={t} />
      </Drawer>
      <Drawer
        anchor={"right"}
        open={drawerState2}
        
        PaperProps={{
          sx: { width: "50%" },
        }}
        onClose={() => {
          setDrawerState2(false);
        }}
      >
        <Button
          sx={{
           
            position: "fixed",
            right: "51%",
            top: 10,
            zIndex: 1,
            minWidth: 0,
            borderRadius: "4px",
            padding: "4px",
            backgroundColor: "#ffc3c3",
            "&:hover": {
              backgroundColor: "#ffc3c3",
            },
          }}
          onClick={() => setDrawerState2(false)}
        >
          <CloseOutlinedIcon color="error" />
        </Button>
        <EntidadeBeneficiaria  t={t} />
      </Drawer>
    </>
  );
};

export default RegisterNotificationData;
